import { render } from "./TheHome.vue?vue&type=template&id=31c3b6b4&scoped=true"
import script from "./TheHome.vue?vue&type=script&lang=js"
export * from "./TheHome.vue?vue&type=script&lang=js"

import "./TheHome.vue?vue&type=style&index=0&id=31c3b6b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c3b6b4"]])

export default __exports__